import { getReport } from './report';
import { generateTicket } from './ticket';

const copyToClipboard = (text) => {
	const textarea = document.createElement('textarea');
	textarea.innerHTML = text;
	document.body.append(textarea);
	textarea.select();
	const result = document.execCommand('copy');
	textarea.remove();
	return result;
};

const handleLocationHash = () => {
	const hash = location.hash.slice(1);
	if (hash === 'report') {
		const report = getReport();
		const ticket = generateTicket(report);
		copyToClipboard(ticket);
	}
};

const api = {
	setup() {
		window.dev = this;
		window.addEventListener('hashchange', handleLocationHash);
	},
	getReport,
	getTicket() {
		const report = getReport();
		return generateTicket(report);
	},
};

export default api;
